<template>
	<div style="padding-bottom: 20px;">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>
		<div class="container">
			<div class="title">
				<h3>{{ details.dispatch_name }}</h3>
				<van-tag style=" margin-left: 8px; flex-shrink: 0;" plain
					:type="details_type[details.dispatch_status].type">{{ details_type[details.dispatch_status].text
					}}</van-tag>
			</div>
			<div class="user">
				<span>发起人: {{ details.initiate_user_name }}</span>
				<span>组织者: {{ details.user_name }}</span>
			</div>
		</div>
		<van-tabs v-model="activeTab">
			<van-tab title="详情">
				<div class="schedule">
					<van-panel :title="details.dispatch_name" :desc="details.dispatch_remark">
						<p>文件列表</p>
						<div class="schedule-body">
							<div class="file-body">
								<div class="file-body-item" v-for="(item, index) in file_list" :key="index">
									<div class="img-body" v-if="isTypeImage(item.file_type)">
										<van-image width="100" height="100" :src="fileUrl + item.file_id"
											@click="imgLook(fileUrl + item.file_id)" />
									</div>
									<div class="img-body" v-else-if="isTypeMp4(item.file_type)"
										@click="lookVideo(fileUrl + item.file_id)">
										<i class="file-icon van-icon-description"></i>
										<div class="file-name">查看视频</div>
									</div>
									<div class="img-body" v-else-if="isType(item.file_type)"
										@click="lookfile(fileUrl + item.file_id)">
										<i class="file-icon van-icon-description"></i>
										<div class="file-name">{{ item.file_name }}</div>
									</div>
									<div class="img-body" v-else @click="clickFile(item.file_type)">
										<i class="file-icon van-icon-description"></i>
										<div class="file-name">
											{{ item.file_name }}.{{ item.file_type }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</van-panel>
				</div>
				<div class="schedule" v-for="(item, index) in assign_list" :key="index">
					<van-panel :title="item.node_name" :desc="item.complete_remark" :status="item.names">
						<div class="schedule-body">
							<van-tag plain :type="assign_status[item.assign_status].type" class="tag-status">{{
								assign_status[item.assign_status].text }}</van-tag>
							<p>开始时间: {{ item.start_date }}</p>
							<p>结束时间: {{ item.complete_date }}</p>
							<div class="file-list-body" v-if="item.file_list != null">
								<p style="margin-top: 15px;">文件列表</p>
								<div class="file-body">
									<div class="file-body-item" v-for="(itemFile, index2) in JSON.parse(
								item.file_list
							)" :key="index2">
										<div class="img-body" v-if="isTypeImage(itemFile.file_type)">
											<van-image width="100" height="100" fit="cover"
												:src="fileUrl + itemFile.file_id" @click="
											imgLook(fileUrl + itemFile.file_id)
										" />
										</div>
										<div class="img-body" v-else-if="isTypeMp4(itemFile.file_type)" @click="
									lookVideo(fileUrl + itemFile.file_id)
								">
											<i class="file-icon van-icon-description"></i>
											<div class="file-name">查看视频</div>
										</div>
										<div class="img-body" v-else-if="isType(itemFile.file_type)"
											@click="lookfile(fileUrl + itemFile.file_id)">
											<i class="file-icon van-icon-description"></i>
											<div class="file-name">{{ itemFile.file_name }}</div>
										</div>
										<div class="img-body" v-else @click="clickFile">
											<i class="file-icon van-icon-description"></i>
											<div class="file-name">
												{{ itemFile.file_name }}.{{
												itemFile.file_type
												}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</van-panel>
				</div>
			</van-tab>
			<van-tab title="勘察单" v-if="survey_list.length > 0 ">
				<div class="schedule">
					<van-list style="padding-bottom: 50px;" >
						<van-swipe-cell v-for="(item, index) in survey_list" :key="index">
							<van-cell class="item-list" @click="viewDetails(item.survey_id)">
								<div class="user-title">
									<span class="user-title-name" style="font-weight: 600;">
										<van-icon name="todo-list-o" />
										{{item.survey_code}}
									</span>
									<span class="user-title-date" style="float: right;">{{item.date}}</span>
								</div>
								<div style="float: left;">
									<van-icon name="wap-home-o" />
									{{item.survey_name}}
								</div>
								<div style="float: left;">
									<van-icon name="records" />
									{{item.led_name}}
								</div>
								<van-tag plain type="success" class="view-button">
									点击查看
								</van-tag>
							</van-cell>
							<div class="divider"></div>
						</van-swipe-cell>
					</van-list>
				</div>
			</van-tab>
			<van-tab title="订单" v-if="order_list.length > 0 ">
				<div class="schedule">
					<van-list style="padding-bottom: 50px;" >
						<van-swipe-cell v-for="(item, index) in order_list" :key="index">
							<van-cell class="item-list" @click="productDetails(item.order_id)">
								<div class="user-title">
									<span class="order-title-name">
										<van-icon name="todo-list-o" />
										{{item.order_name}}
									</span>
									<span class="user-title-date" style="float: right;">{{item.create_date}}</span>
								</div>
								<div>
									<van-icon name="user-o" />
									{{item.client_name}}
								</div>
								<div style="float: left;">
									<van-icon name="cluster-o" />
									{{item.order_code}}
								</div>
								<van-tag plain type="success" class="view-button">
									左滑查看出库记录
								</van-tag>
							</van-cell>
							<div class="divider"></div>
				<template #right>
					<div class="swipe-button" >
						<van-button
							class="swipe-button"
							@click="vieworder(item.order_id)"
							square
							type="primary"
							text="出库记录"
						/>
					</div>
				</template>
						</van-swipe-cell>
					</van-list>
				</div>
			</van-tab>
			<!-- 添加更多选项卡 -->
		</van-tabs>
		<van-popup v-model="videoShow" style="width: 100%" @close="closePanel">
			<video-player id="video" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true"
				:options="playerOptions"></video-player>
		</van-popup>
		<van-popup v-model="showPopup" style="width: 100%;height: 80%;" @opened="pdfpanel">
			<div class="m-pdf">
				<div id="pdf-content"></div>
			</div>
		</van-popup>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { Tab,Tabs,Toast } from "vant";
import { post } from "@/api/dispatch";
import global_url from "@/utils/global";
import { isImage, isMp4, istype } from "@/utils/tool";
import { ImagePreview } from "vant";
import Pdfh5 from "pdfh5";
import "pdfh5/css/pdfh5.css";
// import OtherContent from "@/views/survey/details/details.vue"; // 引入子组件
export default {
	name: "customer",
	components: {
		navbar,
		[Tab.name]: Tab,
		[Tabs.name]: Tabs,
		// OtherContent,
	},
	data() {
		return {
			title: "派单详情",
			details: {
				dispatch_status: 0,
			},
			assign_list: [],
			file_list: [],
			fileUrl: this.findUrl(),
			details_type: [
				{ text: "未分配", type: "default" },
				{ text: "进行中", type: "primary" },
				{ text: "意外终止", type: "danger" },
				{ text: "待确认完成", type: "warning" },
				{ text: "完成", type: "success" },
			],
			assign_status: [
				{ text: "未开始", value: 0, type: "default" },
				{ text: "进行中", value: 1, type: "primary" },
				{ text: "意外终止", value: 2, type: "danger" },
				{ text: "已完成", value: 3, type: "success" },
			],
			playerOptions: {
				autoplay: false,
				muted: false,
				preload: "auto",
				language: "zh-CN",
				aspectRatio: "16:9",
				fluid: true,
				sources: [
					{
						type: "video/mp4",
						src: "",
					},
				],
				notSupportedMessage: "此视频暂无法播放，请稍后再试",
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: false,
				},
			},
			videoShow: false,
			showPopup: false,
			pdfUrl: "",
			activeTab: "", // 默认激活第一个选项卡
			survey_list: [],
			order_list: [],
		};
	},
	mounted() {
		this.getDetails();
	},
	beforeRouteLeave(to, from, next) {
		// 保存当前的 activeTab 状态到路由的 meta 字段
		from.meta.activeTab = this.activeTab;
		next();
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			// console.log(from.path);
			if(from.path == '/dispatch'){
				vm.activeTab = 0;
			}else{
			// 恢复保存的 activeTab 状态
			if (to.meta.activeTab !== undefined) {
				vm.activeTab = to.meta.activeTab;
			}else{
				vm.activeTab = 0;
			}
			}
		});
	},
	methods: {
		closePanel() {
			let video = document.getElementsByTagName("video")[0];
			video.pause();
		},
		lookVideo(url) {
			this.playerOptions.sources[0].src = url;
			this.videoShow = true;
		},
		lookfile(row) {
			this.showPopup = true;
			this.pdfUrl = row
			// console.log(row);

		},
		pdfpanel() {
			//先实例化
			this.pdfh5 = new Pdfh5("#pdf-content", {
				pdfurl: this.pdfUrl,
				goto: 1,
				lazy: true,
			});
			this.pdfh5.scrollEnable(true);
		},
		getDetails() {
			post({
				requestType: "event_list_details",
				dispatch_id: this.$route.query.id,
			})
				.then((res) => {
					this.details = res.obj;
					if (res && res.obj) {
						const parseJson = (jsonString, target) => {
							if (jsonString && jsonString.length > 0) {
								try {
									this[target] = JSON.parse(jsonString);
								} catch (error) {
									console.error(`Failed to parse ${target}:`, error);
								}
							}
						};
						parseJson(res.obj.assign_list, 'assign_list');
						parseJson(res.obj.file_list, 'file_list');
						parseJson(res.obj.survey_list, 'survey_list');
						parseJson(res.obj.order_list, 'order_list');
					}
					// if (res.obj.assign_list && res.obj.assign_list.length != 0) {
					// 	this.assign_list = JSON.parse(res.obj.assign_list);
					// }
					// if (res.obj.file_list && res.obj.file_list.length != 0) {
					// 	this.file_list = JSON.parse(res.obj.file_list);
					// }
					// if (res.obj.survey_list && res.obj.survey_list.length != 0) {
					// 	this.survey_list = JSON.parse(res.obj.survey_list);
					// }
				})
				.catch((err) => {
					console.log(err);
					return Toast.fail("网络异常，请稍后再试！");
				});
		},
		isTypeMp4(name) {
			return isMp4(name);
		},
		isTypeImage(name) {
			return isImage(name);
		},
		isType(name) {
			return istype(name);
		},
		findUrl() {
			return global_url.fileUrl;
		},
		imgLook(url) {
			ImagePreview({
				images: [url],
			});
		},
		clickFile() {
			// console.log(row);
			return Toast.fail("暂不支持该文件查看");
		},
		viewDetails(survey_id) {
			this.$router.push({
				path: "/survey/details",
				query: { id: survey_id, p: false },
			});
			//调转查看页面
			// if (this.survey_id) {
			// 	const id = this.survey_id;
			// 	const resolvedUrl = this.$router.resolve({
			// 		name: 'surveyDetails',
			// 		query: { id: id, type: 0 }
			// 	});
			// 	this.surveyDetailsUrl = resolvedUrl.href;
			// }
		},
		
		vieworder(id) {
			this.$router.push({
				path: "/order/recordingDetails",
				query: {
					id: id,
					type: 0,
					p: 1,
				}
			});
		},
		
		productDetails(order_id) {
			this.$router.push({
				path: "/order/productDetails",
				query: {
					id: order_id,
					p: 1,
				},
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.m-pdf {
	position: fixed;
	top: 0;
	bottom: 0;
	right: 0;
	left: 0;
}

.container {
	padding: 0 20px;

	.title {
		display: flex;
		justify-content: space-between;
		align-items: center;

		h3 {
			margin: 0.5em 0;
		}
	}

	.user {
		span {
			margin: 0.5em 0;
			font-size: 0.8em;

			&+span {
				margin-left: 15px;
			}
		}
	}
}

.file-body {
	width: calc(100% + 10px);
	padding: 0;
	display: flex;
	flex-wrap: wrap;

	.file-body-item {
		list-style: none;
		flex: 0 0 calc(33.33% - 10px);
		margin-right: 10px;
	}
}

.schedule {
	margin-top: 30px;
	// overflow: hidden;

	.van-panel__content {
		padding: 10px 20px;
	}

	&+.schedule {
		margin-top: 15px;
	}

	&-body {
		font-size: 0.8em;
		position: relative;

		p {
			margin: 0.5em 0;
		}

		.tag-status {
			position: absolute;
			right: 0;
			top: 0;
		}
	}

	.file-body {
		display: -webkit-box;
		display: -webkit-flex;
		display: flex;
		-webkit-flex-wrap: wrap;
		flex-wrap: wrap;
		margin-top: 15px;

		// float: left;
		// margin-left: 15px;
		// &:nth-child(3n-2) {
		// 	margin-left: 0;
		// }
		&-item {
			position: relative;
			margin: 0 8px 8px 0;
			cursor: pointer;

			.img-body {
				display: block;
				width: 80px;
				height: 80px;
				overflow: hidden;
				border-radius: 8px;
				box-shadow: #ebedf0 0 4px 12px;
				text-align: center;

				img {
					object-fit: cover;
					display: block;
					width: 100%;
					height: 100%;
				}

				.file-icon {
					position: relative;
					display: inline-block;
					font: normal normal normal 14px/1 "vant-icon";
					font-size: inherit;
					text-rendering: auto;
					-webkit-font-smoothing: antialiased;
					color: #646566;
					font-size: 20px;
					margin-top: 15px;
				}

				.file-name {
					box-sizing: border-box;
					width: 100%;
					margin-top: 4px;
					padding: 0 4px;
					color: #646566;
					font-size: 12px;
					text-align: center;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 3;
					overflow: hidden;
				}
			}
		}
	}
}
.view-button {
  float: right;
  margin-top: 5px;
}
.divider {
  height: 1px;
//   background-color: black; /* 黑色分隔线 */
  margin-top: 10px; /* 分隔线上下间距 */
}
.swipe-button {
	height: 100%;
}
.order-title-name {
//   font-weight: 100;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  max-width: calc(80% - 100px); // 根据实际需要调整宽度
}
</style>
